export default __webpack_public_path__ + "static/media/contact-email.c85e222f.svg";